import { prop } from "vue-class-component";

import { ISetTvaParameters } from "@/models";

export default class SetTvaModalProps {
    parameters: ISetTvaParameters = prop({
        required: true,
    });
}
